export default "__VITE_ASSET__d6eb2ab3__"